/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import React from "react";

import { createPopper } from "@popperjs/core";
import { useTranslation } from 'react-i18next';
import englandFlag from 'assets/img/england.png';
import turkishFlag from 'assets/img/turkey.png'
import history from '../../history';

const IndexDropdown = ({ text = "text-gray-800 hover:text-gray-600" }) => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  const { i18n, t } = useTranslation();
  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
  }
  return (
    <>
      <button
        className={text + " text-white background-transparent font-bold uppercase py-1 text-lg outline-none focus:outline-none mb-1 mt-1 ease-linear transition-all duration-150"}
        ref={btnDropdownRef}
        type="button"
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        {
          history.location.pathname !== "/" ?
            <i className="fas fa-globe-americas fa-2x text-white leading-lg mr-2 "></i>
            :
            <i className="text-lg text-gray-800 leading-lg mr-2 fas fa-language"></i>
        }
      </button>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-white text-base z-50 py-2 list-none text-left rounded-lg shadow-2xl min-w-48"
        }
      >
        <div
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800 cursor-pointer"
          }
          onClick={() => {
            dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
            changeLang('en')
          }}
        >
          <img className="h-6 mr-1 float-left " src={englandFlag} /> English
        </div>
        <div className="h-0 my-2 border border-solid border-gray-200" />
        <div
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-gray-800 cursor-pointer"
          }
          onClick={() => {
            dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
            changeLang('tr');
          }}
        >
          <img className="h-6 mr-1 float-left" src={turkishFlag} /> Türkçe
        </div>
      </div>
    </>
  );
};

export default IndexDropdown;
